import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import {  ExtraSmallButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonEdgeButton from "../Common/CommonEdgeButton";
import { EDGE_EXTRA_SMALL_BUTTONS, EDGE_EXTRA_SMALL_BUTTONS_LIST } from "../../../../Data/Buttons/EdgeStyle";

const EdgeExtraSmallButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={ExtraSmallButton} span={EDGE_EXTRA_SMALL_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="xs" color="primary" className="btn-pill" id="Tooltip-22">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-22" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-primary btn-xs</ToolTip>
          {EDGE_EXTRA_SMALL_BUTTONS_LIST.map((data, index) => (
            <CommonEdgeButton key={index} item={data} size="xs" />
          ))}
        </CardBody>
      </Card>
    );
};

export default EdgeExtraSmallButtons;
